import { render, staticRenderFns } from "./PublishPageEditor.vue?vue&type=template&id=ebc6bfd8"
import script from "./PublishPageEditor.vue?vue&type=script&lang=js"
export * from "./PublishPageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports